import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { compose } from 'react-apollo';
import GraphQLClient from '@api/graphql/GraphQLClient';
import * as Queries from '@api/graphql/queries';
import * as Mutations from '@api/graphql/mutations';
import { updateUserProductDiscountVariables, updateUserShippingDiscountVariables, user, user_listUsers_data_product_discounts, user_listUsers_data_shipping_discounts } from '@api/graphql/types';
import UserDiscountForm from '../components/UserDiscountForm';
import { DiscountType } from '../types';
import Notification from 'components/Notification';

type Props = {
} & InjectedIntlProps & RouteComponentProps;

interface RouteParams {
    userId: string;
    discountType: DiscountType;
    discountId: string;
}

type PropType = Props & InjectedIntlProps & RouteComponentProps<RouteParams>;

interface State {
    formData: updateUserProductDiscountVariables | updateUserShippingDiscountVariables | null;
}

class UserDiscountEdit extends React.Component<PropType, State> {
    constructor(props: PropType) {
        super(props);
        this.state = {
            formData: null,
        };
    }

    public componentDidMount() {
        const variables = {
            page: 1,
            count: 1,
            filters: { id: this.props.match.params.userId },
        };
        GraphQLClient.query<user>({
            query: Queries.user,
            variables,
        }).then((response) => {
            if (response.data && response.data.listUsers && response.data.listUsers.data && response.data.listUsers.data[0].product_discounts && response.data.listUsers.data[0].shipping_discounts) {
                const { discountType, discountId } = this.props.match.params;
                let discount = null;

                if (discountType === DiscountType.productDiscount) {
                    discount = response.data.listUsers.data[0].product_discounts
                        .find((productDiscount: updateUserProductDiscountVariables) => {
                            return productDiscount.id === discountId;
                        });
                } else if (discountType === DiscountType.shippingDiscount) {
                    discount = response.data.listUsers.data[0].shipping_discounts
                        .find((shippingDiscount: updateUserShippingDiscountVariables) => {
                            return shippingDiscount.id === discountId;
                        });
                }
                if (discount) {
                    this.setState({ formData: discount });
                }
            }
        }).catch(() => Notification.error(this.props.intl.formatMessage({ id: 'notification.failed' })));
    }

    private label(id: string): string {
        return this.props.intl.formatMessage({ id: `module.user.${id}` });
    }

    public onSubmit = (formData: user_listUsers_data_product_discounts | user_listUsers_data_shipping_discounts) => {
        const { discountType } = this.props.match.params;

        let mutation = null;
        if (discountType === DiscountType.productDiscount) {
            mutation = Mutations.updateUserProductDiscount;
        } else if (discountType === DiscountType.shippingDiscount) {
            mutation = Mutations.updateUserShippingDiscount;
        } else {
            return Promise.reject(this.props.intl.formatMessage({ id: 'module.user.error.wrong_discount_type' }));
        }

        return GraphQLClient.mutate({
            mutation,
            variables: this.cleanse(formData),
        });
    }

    /**
     * We clean the formData so don't send data like created_at and updated_at
     */
    private cleanse = (formData: user_listUsers_data_product_discounts | user_listUsers_data_shipping_discounts): updateUserProductDiscountVariables | updateUserShippingDiscountVariables => {
        const newFormData = { ...formData };

        Object.keys(newFormData).forEach((key) => {
            if (!(['id', 'is_active', 'discount', 'active_from', 'active_to'].includes(key))) {
                delete newFormData[key];
            }
        });

        return newFormData;
    }

    public render() {
        const { userId, discountType } = this.props.match.params;

        if (!discountType || ((discountType !== DiscountType.productDiscount) && (discountType !== DiscountType.shippingDiscount)) || !userId) {
            Notification.error(this.label('error.wrong_url'));
            return null;
        }

        return (this.state.formData) ? (
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                            <h5>{this.props.intl.formatMessage({ id: `module.user.${discountType}_edit` })}</h5>
                        </div>
                        <div className="ibox-content">
                            <UserDiscountForm
                                discountType={discountType}
                                formData={this.state.formData}
                                onSubmit={this.onSubmit}
                            />
                        </div>
                    </div>
                </div>
            </div>
        ) : null;
    }
}

export default compose(
    injectIntl,
    withRouter,
)(UserDiscountEdit);



// WEBPACK FOOTER //
// ./src/modules/User/pages/UserDiscountEdit.tsx